import React, { useState ,useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Checkbox, TextField, Dialog, DialogActions, DialogTitle, FormControl, Select, MenuItem } from '@mui/material';
import axios from 'axios';



const useStyles = makeStyles((theme) => ({
  boardListBlock:{
    padding:'235px 0 0 0',

    fontFamily:[
        'Noto Sans KR'
    ],

    [theme.breakpoints.down(1025)]: {
      padding:'132px 0 0 0',
    },
  },

  boardListTitleBlock:{
    height:'200px',
    position:'relative',
  },
  boardListH1:{
    fontSize:'38px',
    fontWeight:'500',
    letterSpacing: '-1.9px',
    paddingBottom:'10px',
    position:'absolute',
    top:'40%',
    left:'50%',
    transform:'translate( -50%, -50%)'
  },
  row:{
    maxWidth:'1280px', 
    margin:'0 auto', 
    [theme.breakpoints.down(1025)]: {
      marginTop: 20,
  },
  },
  boardListDiv:{
    border:'1px solid #ccc',
    background:'#fff',
    height:'80px',
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'space-evenly',
    alignItems:'center',
    position:'absolute',
    top:'-40px',
    left:'0%',
    padding:'15px',
    position:'relative',
    [theme.breakpoints.down(1025)]: {
      display:'none',
    },
  },
  boardListDivM: {
    marginTop: -50,
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
  },
  boardListMenuDiv:{
    color:'#555555', 
    letterSpacing: '-0.8px',
    cursor: 'pointer',   
    "&:hover": {
      color: '#007235',
    },
  },
  appListH3:{
    borderBottom:'2px solid #007235',
    fontWeight:'400',
    paddingBottom:'15px',
    fontSize:'17px',
    letterSpacing: '-0.8px',
  },
  BoardWriteForm:{
    color:'#232323',

    [theme.breakpoints.down(1025)]: {
      padding:'0 20px',
    }
  },
  appListLi:{
    padding:'20px 0 0 0px',
    display:'flex',
    '&:first-child':{
      padding:'40px 0 0 0px',
    },
  },
  paddingDiv:{
    paddingBottom:'10px',
    width:'10%',

    [theme.breakpoints.down(631)]: {
      width:'25%',
    },
  },
  pilsooItem:{
    fontSize:'15px',
    letterSpacing: '-0.7px',
  },
  appContent:{
    width:'60%',
    [theme.breakpoints.down(1025)]: {
      width:'100%',
    },
  },
  appContentFile:{
    width:'80%',
    display:'flex',

    [theme.breakpoints.down(821)]: {
      width:'100%',
    },
  },
  appContentIdBtn:{
    width:'25%'
  },
  appContentInput:{
    width:'100%',
    height: '40px',
    padding:'0 0 0 8px',
    borderRadius:'3px',
    border:'1px solid #CCCCCC',
    '&:focus-within':{
      outline:'none'
    },
  },
  appContentInputContent:{
    width:'100%',
    height: '250px',
    padding:'0 0 0 8px',
    borderRadius:'3px',
    border:'1px solid #CCCCCC',
    '&:focus-within':{
      outline:'none'
    },
  },
  btnDiv:{
    textAlign:'center',
    margin:'50px 0'
  },
  fileInput:{
    display: 'inline-block',
    padding: '.5em 1em',
    height: '40px',
    fontSize: '14px',
    backgroundColor: '#555555',
    color:'#fff',
    fontWeight:'600',
    cursor: 'pointer',
    borderRadius: '0px 3px 3px 0px',
    letterSpacing: '-0.7px',

    [theme.breakpoints.down(376)]: {
      fontSize: '12px',
    },

  },
  formBtn:{
    marginTop:'60px',
    textAlign:'center',
  },
}));

const BoardUpdate = () => {
  const location = useLocation();
  const theme = useTheme(); 
  const classes = useStyles(theme);
  const login = useSelector(state => state.user.login);
  let navigate = useNavigate();

  const [wrSubject, setWrSubject] = useState('');
  const [wrContent, setWrContent] = useState('');
  const [wrLink1, setWrLink1] = useState('');
  const [fileFile1, setFile1] = useState('');
  const [fileFile2, setFile2] = useState('');
  const [wrOption, setWrOption] = useState('');
  const [files, setFiles] = useState([])
  const [fileDelList, setFileDelList] = useState([])

  const [dialog, setDialog] = useState('');

  const [menuVal, setMenuVal] = useState('');

  const imageInput1 = useRef();
  const imageInput2 = useRef();



  const onCickImageUpload1 = () => {
    imageInput1.current.click();
  };

  const onCickImageUpload2 = () => {
    imageInput2.current.click();
  };

  const getItem = async() => {
    try{
      const res = await axios.post('/api/board/getBoardEdit/', {boardType: location.state.cateType  , wr_id : location.state.wrId})
      if (res.data.success === false) {
          setDialog('불러오기 실패')
          return
      }

      setWrSubject(res.data.content['wr_subject'])
      setWrContent(res.data.content['wr_content'])
      setWrLink1('')
      setWrOption(res.data.content['wr_option'])

      setFiles(res.data.files)
      
      if(res.data.files[0]){
        setFile1(res.data.files[0]['bf_file'])
      }
      if(res.data.files[1]){
        setFile2(res.data.files[1]['bf_file'])
      } 
      

    } catch (e) {
        console.log(e)
    }
  }

  useEffect(() => {
    setMenuVal(BoardList.find(itm => itm.name === location.state.cateType).text)
    if(location.state.cateType && location.state.wrId){
      getItem()
    }
  }, [location.state.cateType, location.state.wrId])


  useEffect(() => {
    if(!login) {
      navigate('/Login')
    }
  }, [login])

  const onSubmit = async() => {
    if (wrSubject === '') {
      setDialog('제목을 입력하세요.')
      return
    }
    if (wrContent === '') {
      setDialog('내용을 입력하세요.')
      return
    }

    if (wrSubject.length < 5) {
      setDialog('제목을 5자 이상 입력하세요.')
      return
    }

    if (wrContent.length < 5) {
      setDialog('내용을 5자 이상 입력하세요.')
      return
    }

    const checkList = files.reduce((result, item) => [...result, item['bf_file']], [])

    if(checkList.includes(fileFile1)){
      setFile1('')
    }

    if(checkList.includes(fileFile2)){
      setFile2('')
    }

    let formData = new FormData();
    let ip = ''

    // try {
    //   const response = await axios.get('https://api.ipify.org?format=json');
    //   ip = response.data.ip;
    // }catch (error) {
    //   console.error(error);
    //   return
    // }

    formData.append('boardType', location.state.cateType)
    formData.append('wr_id', location.state.wrId)
    formData.append('wr_option', wrOption)
    formData.append('wr_subject', wrSubject)
    formData.append('wr_content', wrContent)
    formData.append('wr_link1', wrLink1)
    formData.append('wr_ip', ip)
    formData.append('file_del_list', fileDelList)
    formData.append('file1', fileFile1)
    formData.append('file2', fileFile2)

    try {
      const res = await axios.post(
                            '/api/board/setBoardEdit/',
                            formData, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data'
                              }
                            }
      )

      if(!res.data.success) {
        setDialog('작성을 실패하였습니다.')
        return
      }

      navigate("/BoardList", {
        state: { cateType: location.state.cateType }
      });

    } catch(e) {
      console.log(e)
    }

  }

  useEffect(() => {

    return () => {
      setWrSubject('')
      setWrContent('')
      setWrLink1('')
      setFile1('')
      setFile2('')
      setWrOption('')
      setFiles([])
      setFileDelList([])
    }
  }, [])

  const BoardList = [
    {name:'qanda', text:'질문과 답변'},
    {name:'notice', text:'공지사항'},
    {name:'after', text:'사용후기'},
    {name:'fag', text:'자주하는 질문'}
  ]

  const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250,
        },
    },
  };

  return (
    <div>
      <div className={classes.boardListBlock}>
        <div 
          className={classes.boardListTitleBlock} 
          style={{ backgroundImage:`url(/images/BoardList_banner.png)`}}
        >
          <h1 className={classes.boardListH1}>
            {location.state.cateType && BoardList.find((item) => location.state.cateType === item.name).text}
          </h1>
        </div>
        <div className={classes.row}>
          <div className={classes.boardListDiv}>
            { BoardList.map( (boardmenu, index) => (
              <div 
                  key={index} 
                  className={classes.boardListMenuDiv}
                  onClick={() => { 
                      navigate("/BoardList", {
                          state: { cateType: boardmenu.name }
                        });
                  }}
              >
                  {boardmenu.text}
              </div>
            ))}
          </div>
          <div className={classes.boardListDivM}>
            <FormControl sx={{ m: 1, width: 300, backgroundColor: '#fff', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',}}>
            <Select
                value={menuVal}
                onChange={(e) => setMenuVal(e.target.value)}
                inputProps={{ 
                    'aria-label': 'Without label' ,
                }}
                MenuProps={MenuProps}
                sx={{
                    backgroundColor: '#fff',
                    height: 50,
                    textAlign: 'center',
                    '.MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                }}
            >      
                {BoardList.map((itm, idx) => (
                <MenuItem
                    key={idx} 
                    onClick={() => { 
                    navigate("/BoardList", {
                        state: { cateType: itm.name }
                    });
                    }}
                    value={itm.text}
                >
                    {itm.text}
                </MenuItem>
                ))}

                
            </Select>
            </FormControl>
        </div>
        </div>
        <div className={classes.row}>
          <div className={classes.BoardWriteForm}>
            <h3 className={classes.appListH3}>{location.state.cateType && BoardList.find((item) => location.state.cateType === item.name).text} 글수정</h3>
            <ul className={classes.appList}>
              <li className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>제목</label>
                </div>
                <div className={classes.appContent}>
                  <input 
                    value={wrSubject}
                    type='text' 
                    className={classes.appContentInput} 
                    onChange={ (e) => {setWrSubject(e.target.value)}}
                  />
                </div>
              </li>
              <li className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>비밀글</label>
                </div>
                <div className={classes.appContent}>
                  <Checkbox
                    checked={wrOption === 'secret' ? true : false}
                    onChange={() => {
                      wrOption === 'secret' ?
                      setWrOption('') :
                      setWrOption('secret')
                    }}
                  />
                </div>
              </li>
              <li className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>내용</label>
                </div>
                <div className={classes.appContent}>
                  <TextField 
                    value={wrContent}
                    multiline
                    sx={{"& .MuiInputBase-root": {minHeight: 300}}} 
                    fullWidth
                    onChange={ (e) => {setWrContent(e.target.value)}}
                  />
                </div>
              </li>
              <li className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>링크</label>
                </div>
                <div className={classes.appContent}>
                  <input 
                    value={wrLink1}
                    type='text' 
                    className={classes.appContentInput} 
                    onChange={ (e) => {setWrLink1(e.target.value)}}
                  />
                </div>
              </li>
              <li className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>첨부파일1</label>
                </div>
                <div className={classes.appContentFile}>
                  <div className={classes.appContent}>
                    <input 
                      value={typeof(fileFile1) === 'string' ? fileFile1 : fileFile1.name}
                      disabled
                      type='text' 
                      className={classes.appContentInput} 
                      onChange={ (e) => {setFile1(e.target.value)}}
                    />
                  </div>
                  <div className={classes.fileDiv}>
                    <input 
                      type="file" 
                      accept=".gif, .jpg, .jpeg, .png, .pdf"
                      style={{ display: "none" }} 
                      ref={imageInput1}
                      onChange={ (e) => {setFile1(e.target.files[0])}}
                    />
                    {fileFile1 === '' && (
                      <button 
                        onClick={onCickImageUpload1}
                        className={classes.fileInput}                      
                      >
                        파일선택1
                      </button>
                    )}

                  </div>
                  {fileFile1 !== '' && (
                      <Button
                        style={{
                          color:'#232323',
                          border:'2px solid #232323',
    
                          fontFamily:[
                            'Noto Sans KR'
                          ],
                        }}
                        variant='outlined'
                        onClick={ () => {
                          if(files.filter((itm) => itm['bf_file'] === fileFile1)[0]){
                            setFileDelList([...fileDelList, files.filter((itm) => itm['bf_file'] === fileFile1)[0]['bf_no']])
                          }
                          setFile1('')
                        }}
                      >
                        삭제
                      </Button>
                  )}

                </div>
              </li>
              <li  className={classes.appListLi}>
                <div className={classes.paddingDiv}>
                  <label className={classes.pilsooItem}>첨부파일2</label>
                </div>
                <div className={classes.appContentFile}>
                  
                  <div className={classes.appContent}>
                    <input 
                      value={typeof(fileFile2) === 'string' ? fileFile2 : fileFile2.name}
                      disabled
                      type='text'
                      className={classes.appContentInput} 
                      onChange={ (e) => {setFile2(e.target.value)}}
                    />
                  </div>
                  <div className={classes.fileDiv} >
                    <input 
                      type="file" 
                      accept=".gif, .jpg, .jpeg, .png, .pdf"
                      style={{ display: "none" }} 
                      ref={imageInput2}
                      onChange={ (e) => {setFile2(e.target.files[0])}}
                    />
                    {fileFile2 === '' && (
                      <button 
                        onClick={onCickImageUpload2}
                        className={classes.fileInput}                      
                      >
                        파일선택2
                      </button>
                    )}

                  </div>
                  {fileFile2 !== '' && (
                    <Button
                      style={{
                        color:'#232323',
                        border:'2px solid #232323',
  
                        fontFamily:[
                          'Noto Sans KR'
                        ],
                      }}
                      variant='outlined'
                      onClick={ () => {
                        if(files.filter((itm) => itm['bf_file'] === fileFile2)[0]) {
                          setFileDelList([...fileDelList, files.filter((itm) => itm['bf_file'] === fileFile2)[0]['bf_no']])
                        }
                        setFile2('')
                      }}
                    >
                      삭제
                    </Button>
                  )}

                </div>
              </li>
            </ul>
          </div> 
          <div className={classes.formBtn}>
            <Button 
              onClick={onSubmit}
              variant="outlined" 
              sx ={{
                color: "#ffff", 
                background:'#007235', 
                border:'none',
                fontSize:'16px',
                fontWeight:'400',
                width:{
                  xs: "90%",
                  sm: "90%",
                  md: "200px",
                  lg: "200px",
                  xl: "200px"
                }, 
                height: {
                  xs: "40px",
                  sm: "40px",
                  md: "54px",
                  lg: "54px",
                  xl: "54px"
                },
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}
            >
              작성완료
            </Button>  
          </div>
        </div>
      </div>
      <Dialog
          open={dialog === '' ? false : true}
          onClose={() => setDialog('')}
      >
          <DialogTitle id="alert-dialog-title">
              {dialog}
          </DialogTitle>
          <DialogActions>
              <Button onClick={() => setDialog('')} autoFocus>
                  확인
              </Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default BoardUpdate
